import React from 'react'

import { Box, Dropdown, Icon, IconButton } from 'stardust'

import { DropdownMenuItem, DropdownMenuItemProps } from '~/components/DropdownMenu'

interface Props {
  items: DropdownMenuItemProps[]
}

const OverflowMenu = ({ items }: Props) => (
  <Box cursor="pointer" data-test="overflow-menu">
    <Dropdown
      renderButton={({ handleClose }) => (
        <IconButton onClick={handleClose} icon={<Icon name="overflow" fill="textPrimaryMedium" />} />
      )}
      render={({ handleClose }) =>
        items.map((item) => {
          const onClick = () => {
            handleClose()
            item.onClick()
          }

          return <DropdownMenuItem key={item.label} label={item.label} onClick={onClick} />
        })
      }
    />
  </Box>
)

OverflowMenu.displayName = 'OverflowMenu'

export default React.memo(OverflowMenu)
